module.exports = __webpack_public_path__ + "static/media/footer-shape.908cea81.png";